export default {
  TYPE_FILE: 'MATERIAL_TYPE_FILE',
  TYPE_FOLDER: 'MATERIAL_TYPE_FOLDER',
  TYPE_NOTE: 'MATERIAL_TYPE_NOTE',
  TYPE_LINK: 'MATERIAL_TYPE_LINK'
};